import React from 'react';
import { CancelModal } from '../../../../components';

interface EditDrawerCancelModalProps {
    cancelModal: boolean;
    handleCancelModal: () => void;
    handleCancel: () => void;
}

export const EditDrawerCancelModal = ({
    cancelModal,
    handleCancelModal,
    handleCancel,
}: EditDrawerCancelModalProps): React.JSX.Element => {
    return (
        <CancelModal
            cancelModal={cancelModal}
            handleCancelModal={handleCancelModal}
            cancelButtonText='Close without saving'
            cancelHeadingText='Are you sure you want to abandon your changes?'
            cancelSubHeadingText='This dictionary has unsaved changes. Are you sure you want to close without saving? You will lose all changes.'
            handleCancel={handleCancel}
        />
    );
};
